module.exports = __webpack_public_path__ + "static/steven-2c214c0edd0cc5a32aba8f6ad2dd8f4f.jpg";